module.exports = __webpack_public_path__ + "img/xinyangjiaotong.7d5d2692.png";